import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";
import { isNumericWithPlus } from "../utilityFunctions";
import { setLocalStorageTokens } from "../tokenUtils";

export const signUp = async (newUserInfo) => {
  const formattedNewUserInfo = formatLoginInfo(newUserInfo);
  const signUpResponse = await axios.post(
    apiRoutes.SIGN_UP,
    formattedNewUserInfo,
  );
  const signUpData = signUpResponse.data;
  setLocalStorageTokens(signUpData);
  return signUpData;
};

const formatLoginInfo = (loginInfo) => {
  const formattedNewUserInfo = { ...loginInfo };
  if (isNumericWithPlus(loginInfo.authId)) {
    formattedNewUserInfo.phoneNumber = loginInfo.authId;
    delete formattedNewUserInfo.email;
  } else {
    formattedNewUserInfo.email = loginInfo.authId;
    delete formattedNewUserInfo.phoneNumber;
    delete formattedNewUserInfo.country;
  }
  delete formattedNewUserInfo.authId;
  return formattedNewUserInfo;
};

export const login = async (loginInfo) => {
  // Login page sends { phoneNumber, country, password } directly.
  // formatLoginInfo handles the legacy authId shape used by signUp.
  const formattedLoginInfo = loginInfo.phoneNumber
    ? loginInfo
    : formatLoginInfo(loginInfo);
  const loginResponse = await axios.post(apiRoutes.LOGIN, formattedLoginInfo);
  const loginData = loginResponse.data;
  setLocalStorageTokens(loginData);
  return loginData;
};
export { setLocalStorageTokens } from "../tokenUtils";

export const attemptAutoLogin = async () => {
  // Send our own refresh token so the backend can rotate this session's own
  // entry instead of appending a new one on every app open/tab load. The
  // interceptor fills it in (see sendRefreshToken in appAxios.js).
  const loginResponse = await axios.post(
    apiRoutes.AUTO_LOGIN,
    {},
    { sendRefreshToken: true },
  );
  const loginData = loginResponse.data;
  setLocalStorageTokens(loginData);
  return loginData;
};

export const logout = async () => {
  // Send our own refresh token so the backend invalidates only this
  // session, not every other logged-in device/tab.
  const loginResponse = await axios.post(
    apiRoutes.LOGOUT,
    {},
    { sendRefreshToken: true },
  );
  const loginData = loginResponse.data;
  return loginData;
};

export const googleAuthInitiate = async (idToken) => {
  const response = await axios.post(apiRoutes.GOOGLE_AUTH, { idToken });
  if (response.data.accessToken) {
    setLocalStorageTokens(response.data);
  }
  return response.data;
};

export const verifyEmail = async (verificationToken) => {
  const verificationResponse = await axios.get(apiRoutes.VERIFY_EMAIL, {
    params: { token: verificationToken },
  });

  const verificationData = verificationResponse.data;
  return verificationData;
};
